module.exports = __webpack_public_path__ + "img/dsgvo.3f65fcfe.svg";